module.exports = function(app) {
    'use strict';

    app.controller('pages.employee.add.mnloa', ['$state', 'services', '$scope', 'employee',
		function ($state, services, $scope, employee) {
			employee.loadEnrollment( $state.params.subscriberSSN ).then(
				function(employee) {
					$scope.employee = employee;
				}
			);
		}
	]);
};
